import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import FooterOne from "../components/FooterOne";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import BottomFooter from "../components/BottomFooter";

const ShopPage = () => {
  const { cat_id, sub_cat_id } = useParams(); // Extract path parameters
  const [searchParams] = useSearchParams(); // Extract query parameters
  const [searchQuery, setSearchQuery] = useState({
    search: "%", 
    cat_id: cat_id || null, 
    sub_cat_id: sub_cat_id || null, 
  });

  useEffect(() => {
    // Update searchQuery state whenever the URL parameters or query strings change
    const params = Object.fromEntries(searchParams.entries());
    setSearchQuery({
      search: params.search || "%",
      cat_id: cat_id || params.cat_id || null,
      sub_cat_id: sub_cat_id || params.sub_cat_id || null,
    });
  }, [searchParams, cat_id, sub_cat_id]); // Dependencies track changes in URL parts

  console.log("Search query from the page level:", searchQuery);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* ShopSection */}
      <ShopSection searchparams={searchQuery} />

      {/* ShippingTwo */}
     

      {/* FooterOne */}
      <FooterOne />
      <BottomFooter/>
 
    </>
  );
};

export default ShopPage;
